<template>
  <span>Administration Espace Employeur</span>
</template>

<script>
export default {};
</script>

<style>
</style>
